import type { RootState } from '@/store';

export const selectAudienceTemplates = (state: RootState) => state.audienceTemplates.templates;
export const selectAudienceTemplatesLoading = (state: RootState) => state.audienceTemplates.loading;
export const selectAudienceTemplatesSaving = (state: RootState) => state.audienceTemplates.saving;
